"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var getCSSRules = function (_a, style) {
    var colors = _a.colors, borderRadius = _a.borderRadius;
    return ({
        card: __assign({ position: 'relative', backgroundColor: colors.Grey[0], boxShadow: '0px 1px 8px rgba(0, 0, 0, 0.1)', padding: 15, boxSizing: 'border-box', borderRadius: borderRadius.sm, border: "1px solid ".concat(colors.Grey[0]), transition: 'all ease .25s' }, style),
        hoverable: {
            cursor: 'pointer',
            '&:hover': {
                borderColor: colors.Hannibal[600],
                boxShadow: "0px 1px 8px ".concat(colors.Hannibal[600], "1f"),
            },
        },
        error: {
            borderColor: colors.Red[600],
            boxShadow: '0px 1px 8px rgba(246, 48, 65, 0.24)',
        },
        disabled: {
            cursor: 'default',
            opacity: 0.5,
        },
        active: {
            backgroundColor: colors.Hannibal[100],
            borderColor: colors.Hannibal[600],
            boxShadow: "0px 1px 8px ".concat(colors.Hannibal[600], "1f"),
        },
        icon: {
            width: 48,
            height: 48,
            borderRadius: 18,
            marginTop: -24,
            backgroundImage: "linear-gradient(135deg, ".concat(colors.Grey[300], " 5%, ").concat(colors.Grey[200], " 95%);"),
            overflow: 'hidden',
            '& img': {
                maxWidth: '100%',
                height: '100%',
            },
        },
        menu: {
            position: 'absolute',
            top: 5,
            right: 3,
        },
    });
};
var Card = function (_a) {
    var children = _a.children, style = _a.style, active = _a.active, hoverable = _a.hoverable, error = _a.error, disabled = _a.disabled, icon = _a.icon, renderIcon = _a.renderIcon, menu = _a.menu, rest = __rest(_a, ["children", "style", "active", "hoverable", "error", "disabled", "icon", "renderIcon", "menu"]);
    var theme = (0, react_1.useTheme)();
    var styles = getCSSRules(theme, style);
    var handleMenuClick = function (e) {
        e.stopPropagation();
    };
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ css: (0, react_1.css)(styles.card, active && styles.active, hoverable && styles.hoverable, error && styles.error, disabled && styles.disabled) }, rest, { children: [!!icon && !renderIcon && ((0, jsx_runtime_1.jsx)("div", __assign({ css: (0, react_1.css)(styles.icon) }, { children: typeof icon === 'string' && (0, jsx_runtime_1.jsx)("img", { src: icon, alt: "Card Icon" }, void 0) }), void 0)), (0, jsx_runtime_1.jsx)(react_1.ClassNames, { children: function (_a) {
                    var css = _a.css;
                    return renderIcon && renderIcon(css(styles.icon));
                } }, void 0), !!menu && ((0, jsx_runtime_1.jsx)("div", __assign({ onClick: handleMenuClick, css: (0, react_1.css)(styles.menu) }, { children: menu }), void 0)), children] }), void 0));
};
exports.default = Card;
//# sourceMappingURL=index.js.map